<template>
  <div class="site-contents dashboard d-flex align-items-center flex-wrap">
    <div class="container">
      <div class="event-lists events-wrap d-flex flex-wrap justify-content-between">
        <h2 v-if="hosted == '' && participated == ''">Archived wish lists not found.</h2>
        <h2 v-show="hosted && hosted.length > 0">Archived hosted events</h2>

        <div
          v-for="(event,index) in hosted"
          class="registry-lists d-flex flex-wrap w-100"
          v-bind:key="event._id"
        >
          <div class="event-img">
            <img v-if="event.image" :src="event.image" />
            <img v-else src="../../public/assets/images/event1.png" />
          </div>
          <div
            class="event-info flex-grow-1"
            v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
          >
            <router-link :to="{ path: 'wishlist/'+event._id}">
              <h4>{{event.name}}</h4>
            </router-link>
            <div class="event-date">
              <template v-if="calculateDateDiff(event.date) == false">
                <p>This event is over.</p>
              </template>
              <template v-else>
                <p>This event is archived.</p>
                <p class="date">{{ new Date(event.date).toString() | moment("DD/MM/YYYY")}}</p>
              </template>
            </div>
            <div class="dropdown dropdown-icon show">
              <span
               
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              ></span>
              <div class="dropdown-menu dropdown-menu-right show" aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" @click="unarchiveWishlist(index,event._id)" v-if="calculateDateDiff(event.date) == true"> <span class="text">Unarchive</span>
                    <span class="icon-default"> <img src="../../public/assets/images/archive.png" /></span>
                    <span class="icon-hover"> <img src="../../public/assets/images/archive-hov.png" /></span></a>
                <a class="dropdown-item" @click="deleteWishlist(index,event._id)">
                  <span class="text">Delete</span>
                    <span class="icon-default"> <img src="../../public/assets/images/delete.png" /></span>
                    <span class="icon-hover"> <img src="../../public/assets/images/delete-hov.png" /></span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <router-link
          v-if="totalHosted > listTotal"
          to="/hostedArchive"
          data-toggle="modal"
          class="view-all btn btn-default"
        >View all</router-link>
      </div>

      <div class="event-lists events-participating d-flex flex-wrap justify-content-between">
        <h2 v-if="participated && participated.length > 0">Archived participated events</h2>

        <div
          v-for="(event,index) in participated"
          v-bind:key="event._id"
          class="registry-lists d-flex flex-wrap w-100"
        >
          <div class="event-img">
            <img v-if="event.image" :src="event.image" />
            <img v-else src="../../public/assets/images/event1.png" />
          </div>
          <div
            class="event-info flex-grow-1"
            v-bind:class="{ bgWhite: ((index%2) !== 0 || index == 1) }"
          >
            <router-link :to="{ path: 'wishlist/'+event._id}">
              <h4>{{event.name}}</h4>
            </router-link>
            <div class="event-date">
              <template v-if="calculateDateDiff(event.date) == false">
                <p>This event is over.</p>
              </template>
              <template v-else>
                <p>This event is archived.</p>
                <p class="date">{{ new Date(event.date).toString() | moment("DD/MM/YYYY")}}</p>
              </template>
            </div>
          </div>
        </div>
        <router-link
          v-if="totalParticipated > listTotal"
          to="/participatedArchive"
          data-toggle="modal"
          class="view-all btn btn-default"
        >View all</router-link>
      </div>
    </div>
    <div
      class="modal fade"
      id="confirm-delete"
      tabindex="-1"
      role="dialog"
      aria-labelledby="myModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 v-if="isDelete===false">Unarchive event</h5>
            <h5 v-else>Delete event</h5>
            <img
              class="close"
              src="../../public/assets/images/close.svg"
              data-dismiss="modal"
              aria-label="Close"
            >
      </div>
          <div class="modal-body">
            <h4>Are you sure?</h4>
            </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
            <button
              type="button"
              class="btn btn-primary"
              v-model="confirmed"
              @click="confirmTrue()"
            >Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.addmore a {
  padding-bottom: 10px;
}
.crop-button {
  margin-left: 500px;
  margin-top: 10px;
}
.wishlistCreateForm {
  margin-top: 60px;
}
</style>
<script>
import Vuex from "vuex";
import Vue from "vue";
import {
  GET_ARCHIVED_HOSTED_WISHLIST,
  GET_ARCHIVED_PARTICIPATED_WISHLIST,
  DELETE_WISHLIST,
  UNARCHIVE_WISHLIST
} from "../store/wishlist/action.type";
// import { Validator } from "vee-validate";
import VChip from "v-chip";
import VChipInput from "v-chip/src/v-chip-input.js";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css"; // import the croppie css manually

import ShareWishlist from "./ShareWishlist";
import JoinById from "./JoinById";

Vue.use(VueCroppie);
Vue.use(VChip);
Vue.use(VChipInput);

export default {
  name: "webDashboard",
  components: {
    "share-wishlist": ShareWishlist,
    "join-by-id": JoinById
  },
  data() {
    return {
      hosted: null,
      participated: null,
      listTotal: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3,
      totalHosted: 0,
      totalParticipated: 0,
      name: null,
      image: "",
      celebrant: null,
      location: null,
      detail: null,
      date: null,
      time: null,
      dateOffset: null,
      like: null,
      dislike: null,
      likes: [],
      dislikes: [],
      apiErrorMessage: null,
      apiSuccessMessage: null,
      dismissSecs: 5,
      dismissCountDown: 0,
      uniqueCode: null,
      showSpinner: null,
      disabled: null,
      buttonText: "Create Event",

      //for croppie
      cropped: null,
      file: "",
      showPreview: false,
      imagePreview: null,

      //wihlist actions
      index: null,
      id: null,
      isDelete: false,
      isArchive: false,
      isShare: false,
      confirmed: false,
      wishlistType: null,

      /*SHARE WISHLIST */
      showShareModal: false,
      //paginate
      page: 1,
      perPageLimit: process.env.VUE_APP_API_PER_PAGE_LIMIT || 3
    };
  },
  created() {
    //define default functions
    window.removeLikes = this.removeLikes;
    window.removeDislikes = this.removeDislikes;
  },
  computed: {
    detailCharacterCount() {
      let char = this.detail;
      if (char) {
        return char.length;
      } else {
        return 0;
      }
    }
  },
  mounted() {
    let params = {
      page: this.page,
      perPageLimit: this.perPageLimit
    };
    //get hosted events
    this.getHostedWishlists(params);
    //get participated events
    this.getParticipatedWishlists(params);
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    getHostedWishlists(params) {
      //get hosted events
      this.$store
        .dispatch(GET_ARCHIVED_HOSTED_WISHLIST, params)
        .then(response => {
          // console.log(response);
          this.hosted = response.record;
          this.totalHosted = response.pagination.totalDocs;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getParticipatedWishlists(params) {
      this.$store
        .dispatch(GET_ARCHIVED_PARTICIPATED_WISHLIST, params)
        .then(response => {
          // console.log(response);
          if (response) {
            this.participated = response.record;
            this.totalParticipated = response.pagination.totalDocs;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    /*delete wishlist */
    deleteWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "hosted";
      this.isDelete = true;
      this.isShare = false;
      this.isArchive = false;
    },
    /*delete wishlist */
    unarchiveWishlist(index, id) {
      $("#confirm-delete").modal("show");
      this.index = index;
      this.id = id;
      this.wishlistType = "hosted";
      this.isUnarchive = true;
      this.isShare = false;
      this.isArchive = false;
      this.isDelete = false;
    },

    confirmTrue() {
      $("#confirm-delete").modal("hide");
      let params = {
        page: this.page,
        perPageLimit: this.perPageLimit
      };
      if (this.isDelete) {
        /* delete wishlist api */
        this.$store
          .dispatch(DELETE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              this.$delete(this.hosted, this.index);
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });
        // this.$router.go(this.$router.currentRoute);
        this.getHostedWishlists(params);
      } else if (this.isArchive) {
        /* delete wishlist api */
        this.$store
          .dispatch(ARCHIVE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              if (this.wishlistType === "hosted") {
                this.$delete(this.hosted, this.index);
              } else {
                this.$delete(this.participated, this.index);
              }
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });
        // this.$router.go(this.$router.currentRoute);
        this.getHostedWishlists(params);
      } else if (this.isUnarchive) {
        /* delete wishlist api */
        this.$store
          .dispatch(UNARCHIVE_WISHLIST, this.id)
          .then(response => {
            if (response.status == 200) {
              if (this.wishlistType === "hosted") {
                this.$delete(this.hosted, this.index);
              } else {
                this.$delete(this.participated, this.index);
              }
            } else {
            }
          })
          .catch(error => {
            console.log(error);
          });
        // this.$router.go(this.$router.currentRoute);
        this.getHostedWishlists(params);
      } else {
      }
    },

    //add likes
    clickLike() {
      if (this.like && $.inArray(this.like, this.likes) == -1) {
        let display = "'none'";
        let appendChips =
          '<div><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
        appendChips += this.like;
        appendChips +=
          '</span><span onclick="removeLikes(this)" class="closebtn">×</span></div></div>';
        $(".likes .addmore").prepend(appendChips);

        this.likes.push(this.like);
        this.like = null;
        this.$refs.like.focus();
      }
    },

    removeLikes($this) {
      //remove from array
      var index = this.likes.indexOf(
        $($this)
          .prev(".chip-item")
          .text()
      );
      if (index !== -1) {
        this.likes.splice(index, 1);
      }
      $($this)
        .parent()
        .remove();
      this.$refs.like.focus();
    },
    //add dislikes
    clickDislike() {
      if (this.dislike && $.inArray(this.dislike, this.dislikes) == -1) {
        let display = "'none'";
        let appendChips =
          '<div><div index="0" class="chip" style="color: rgb(51, 51, 51); background-color: rgb(241, 241, 241);"><span class="chip-item">';
        appendChips += this.dislike;
        appendChips +=
          '</span><span onclick="removeDislikes(this)" class="closebtn">×</span></div></div>';
        $(".dislike .addmore").prepend(appendChips);

        this.dislikes.push(this.dislike);
        this.dislike = null;
        this.$refs.dislike.focus();
      }
    },

    removeDislikes($this) {
      //remove from array
      var index = this.dislikes.indexOf(
        $($this)
          .prev(".chip-item")
          .text()
      );
      if (index !== -1) {
        this.dislikes.splice(index, 1);
      }
      $($this)
        .parent()
        .remove();
      this.$refs.dislike.focus();
    },

    // calculate date difference for the wishlist
    calculateDateDiff(date) {
      let eventDate = new Date(date);
      let currentDate = new Date();
      if (eventDate - currentDate > 0) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>